import React from 'react'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { connect } from 'react-redux'
import config from 'config'

// Services
import { accountingPlatformsService, businessService } from '../_services'

// Actions
import { userActions, accountingActions, businessActions } from '../_actions'

// Constants
import colors from '../_constants/colors'
import { tenantColors } from '../_constants/colors'
import ROUTES from '../_constants/routes'

// helpers
import { history } from '../_helpers'
import { tenantHeader, sessionHeader } from '../_helpers'

//config
import { APConfig } from '../_configs/accountingPlatform.config'

// Assets
import accountingPlatformsImg from '../assets/img/pre-int-icn-green.png'
import intuitQuickbooksLogo from '../assets/img/qb_icon_white.png'
import intuitQuickbooksLogoActive from '../assets/img/quickbooks-btn-active.png'
import sageOneLogo from '../assets/img/sageone-btn.png'
import sageOneLogoActive from '../assets/img/sageone-btn-active.png'
import xeroLogo from '../assets/img/xero-btn.png'
import xeroLogoActive from '../assets/img/xero-btn-active.png'
import accountingPlatformsBg from '../assets/img/pre-int-top-bg.png'
import { COMPANY_NAME } from 'xen/constants'

const AccountingPlatformsComponent = styled.div`
  grid-gap: 25px;
  justify-items: center;
  background-image: url(${accountingPlatformsBg});
  background-position: bottom center;
  background-size: cover;
  width: 80%;
  max-width: 800px;
  margin: 0 auto;
  padding: 50px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > * {
    margin-bottom: 25px;

    &:last-child {
      margin-bottom: 0px;
    }
  }

  .title {
    text-align: center;
    font-weight: 400;
    font-size: 45px;
    text-transform: capitalize;
  }

  .steps-overview {
    display: flex;
    align-items: center;
  }

  .steps-list {
    opacity: 0.5;
    line-height: 2em;
    font-weight: 500;
    margin-top: 0;
  }

  .choose-software-heading {
    font-size: 18px;
    margin-top: 10px;
    white-space: pre;
  }

  .accounting-platforms {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    border-spacing: 1em;
    width: 100%;

    button {
      width: 100%;
    }

    @media screen and (min-width: 600px) {
      flex-direction: row;

      button {
        width: 48%;
      }
    }
  }
`

const AccountingBtnStyle = css`
  background-color: ${(props) => tenantColors[props.tenant].primary_button || colors.FINVOICE_BLUE};
  border: 2px solid ${(props) => tenantColors[props.tenant].primary_button || colors.FINVOICE_BLUE};
  height: 100px;
  border-radius: 5px;
  outline: none;
  color: white;
  font-weight: 500;
  font-family: 'Lato', sans-serif;
  font-size: 1.25em;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  width: 48%;
  margin: 1%;
  img {
    max-height: 50px;
  }
  &:hover {
    background-color: ${(props) => tenantColors[props.tenant].footer_header || colors.DEFAULT_FOOTER_HEADER};
    border: 2px solid ${colors.DARK_GREY};
    color: ${(props) => tenantColors[props.tenant].primary || colors.FINVOICE_BLUE};
  }
  flex-grow: 1;
`

const AccountingBtn = styled.button`
  ${AccountingBtnStyle}
`
const NoSoftware = styled.div`
  max-height: 50px;
`
const Footer = styled.div`
  padding-top: 60px;
  padding-bottom: 100px;
  text-align: center;
  display: grid;
  grid-gap: 10px;
`

class AccountingPlatformsPage extends React.Component {
  state = {
    intuitHover: false,
    sageoneHover: false,
    xeroHover: false,
    noSoftwareHover: false,
  }

  fetchOauth2Url = (businessId) => {
    //doing our own implementationn here so that we can set the cookie for platform
    let uri = config.apiUrl + `/quickbooks/oauth2_authenticate/${businessId}`
    let headers = Object.assign(tenantHeader(), sessionHeader())
    let p = new Promise((res, rej) => {
      var xhr = new XMLHttpRequest()
      xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          let ur = new URL(JSON.parse(xhr.responseText).auth_url)
          ur.searchParams.set('state', sessionHeader()['session-token'])
          res(ur.toString())
        }
      }

      xhr.open('GET', uri, true)
      for (let h in headers) {
        xhr.setRequestHeader(h, headers[h])
      }
      xhr.send(null)
    })

    return p
  }

  connectToIntuit = async () => {
    const { user, setAccounting, setBusiness, tenant_id } = this.props
    try {
      let oauthurl = await this.fetchOauth2Url(user.business_id)
      let parameters = 'location=1,width=800,height=650'
      window.open(oauthurl, 'ippPopupWindow', parameters)

      window.addEventListener('message', (ev) => {
        if (ev.data.connected === 'connected') {
          setAccounting(true, 'quickbooks')
          businessService.getBusiness(user.business_id).then((busResp) => {
            setBusiness(busResp)
            history.push(ROUTES.your_invoices)
          })
        }
      })
    } catch (err) {
      console.error(err)
    }
  }

  connectToSageOne = () => {
    const { user } = this.props
    accountingPlatformsService.connectToSageOne(user.business_id).then(
      (resp) => {
        const stateString = btoa(`{"business_id":${user.business_id.toString()}}`)
        window.open(
          `https://www.sageone.com/oauth2/auth?response_type=code&client_id=${resp.data.client_id}&redirect_uri=${resp.data.callback_url}&scope=full_access&state=${stateString}`,
          `_blank`
        )
      },
      (error) => {
        // TODO: Replace below with notification
        // dispatch(alertActions.error(error.toString()))
      }
    )
  }

  connectToXero = () => {
    const { user } = this.props
    accountingPlatformsService.connectToXero(user.business_id).then(
      (resp) => {
        window.open(resp.data.authorize_url, `_blank`)
      },
      (error) => {
        // TODO: Replace below with notification
        // dispatch(alertActions.error(error.toString()))
      }
    )
  }

  handleMouseEnter = (e) => {
    this.setState({
      [e.target.name]: true,
    })
  }

  handleMouseLeave = (e) => {
    this.setState({
      [e.target.name]: false,
    })
  }

  render() {
    const { user, setFlowStep, tenant } = this.props
    //pull styled button and programmatically navigate to keep cross-browser styles consistent
    const AccountingBtnLinkHistory = withRouter(({ history }) => (
      <AccountingBtn
        onClick={() => {
          setFlowStep(user.id, 'redirected_to_first_tab')
          history.push(ROUTES.upload_invoices)
        }}
        tenant={tenant}
      >
        <NoSoftware tenant={tenant}>Skip</NoSoftware>
      </AccountingBtn>
    ))
    const conf = APConfig[tenant]
    //if no accounting platforms are enabled go straight to confirm form
    if (!conf.quickbooks_enabled && !conf.sage_one_enabled && !conf.xero_enabled) {
      history.push(ROUTES.upload_invoices)
    }
    return (
      <AccountingPlatformsComponent className="accounting-platforms-pg">
        <Helmet>
          <title>Accounting Platforms • {COMPANY_NAME}</title>
        </Helmet>
        <h1 className={`title`}>{conf.title}</h1>
        <div className="steps-overview">
          <img alt="" src={accountingPlatformsImg} />
          <ol className="steps-list">
            {conf.steps.map((label) => (
              <li key={label}>{label}</li>
            ))}
          </ol>
        </div>
        <p className="choose-software-heading">{conf.account_software_title}</p>
        <div className="accounting-platforms">
          {conf.quickbooks_enabled && (
            <AccountingBtn
              name={`intuitHover`}
              onClick={this.connectToIntuit}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
              tenant={tenant}
            >
              {this.state.intuitHover ? (
                <img alt={`Connect to Quickbooks`} src={intuitQuickbooksLogoActive} />
              ) : (
                <img alt={`Connect to Quickbook`} src={intuitQuickbooksLogo} />
              )}
            </AccountingBtn>
          )}
          {conf.sage_one_enabled && (
            <AccountingBtn
              name={`sageoneHover`}
              onClick={this.connectToSageOne}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
              tenant={tenant}
            >
              {this.state.sageoneHover ? (
                <img alt={`Connect to SageOne`} src={sageOneLogoActive} />
              ) : (
                <img alt={`Connect to SageOne`} src={sageOneLogo} />
              )}
            </AccountingBtn>
          )}
          {conf.xero_enabled && (
            <AccountingBtn
              name={`xeroHover`}
              onClick={this.connectToXero}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
              tenant={tenant}
            >
              {this.state.xeroHover ? (
                <img alt={`Connect to Xero`} src={xeroLogoActive} />
              ) : (
                <img alt={`Connect to Xero`} src={xeroLogo} />
              )}
            </AccountingBtn>
          )}
          <AccountingBtnLinkHistory tenant={tenant} />
        </div>
        <Footer className="accounting-platforms-footer">
          <h1>{conf.help_title}</h1>
          <p>
            {conf.chat_url ? <a href={conf.chat_url}>Chat with us</a> : 'Chat with us'} | Call:{' '}
            <a href={`tel:${conf.help_number.replace(/[\D]/g, '')}`}>{conf.help_number}</a>
          </p>
        </Footer>
      </AccountingPlatformsComponent>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getBusiness: (businessId) => {
      dispatch(businessActions.getBusiness(businessId, false))
    },
    setFlowStep: (userId, value) => {
      dispatch(userActions.updateUser('flow_step', value, userId))
    },
    setAccounting: (accounting_connected, accounting_platform) => {
      dispatch(accountingActions.setAccounting(accounting_connected, accounting_platform))
    },
    setBusiness: (business) => {
      dispatch(businessActions.setBusiness(business))
    },
  }
}

function mapStateToProps(state) {
  const { user, env, tenant } = state
  return {
    user,
    tenant: env.tenant,
    tenant_id: tenant.id,
  }
}

const connectedAccountingPlatformsPage = connect(mapStateToProps, mapDispatchToProps)(AccountingPlatformsPage)
export { connectedAccountingPlatformsPage as AccountingPlatformsPage }
